import PriceitemSelector from './priceitem-selector.vue';

export default {
  install(application) {
    application.component('yx-priceitem-selector', PriceitemSelector);
  },
};
